module.exports = __webpack_public_path__ + "img/nav-managed.c9225de8.svg";